export default __webpack_public_path__ + "static/media/TVS Stryker 125 catalogo 2021.8fca3ec6.pdf";